import { BOOKINGS } from "../../actions/type";

export default function booking(state = [], action) {
    switch (action.type) {
        case BOOKINGS:
            return action.payload;;
        default:
            return state
    }
}